import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import HomeScreen from "./pages/HomeScreen";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { decodeJwt } from "./util/decodeJwt";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

/* =====================================================
   ROUTER WRAPPER
===================================================== */
export default function AppWrapper() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

/* =====================================================
   MAIN ROUTES
===================================================== */
function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  const navigate = useNavigate();

  /* =====================================================
     APPLY THEME FROM STORED ROLE
  ===================================================== */
  useEffect(() => {
    const role = localStorage.getItem("userRole");

    document.body.classList.remove("admin-theme", "manufacturer-theme");

    if (role === "admin") {
      document.body.classList.add("admin-theme");
    } else {
      document.body.classList.add("manufacturer-theme");
    }
  }, [isLoggedIn]);

  /* =====================================================
     LOGOUT
  ===================================================== */
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");

    setIsLoggedIn(false);

    document.body.classList.remove("admin-theme");
    document.body.classList.add("manufacturer-theme");

    toast.success("Logout successful!");
    navigate("/", { replace: true });
  };

  /* =====================================================
     LOGIN SUCCESS
  ===================================================== */
  const handleLoginSuccess = () => {
    setIsLoggedIn(true);

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    try {
      const decoded = decodeJwt(token);
      const role = decoded?.role || "manufacturer";

      // ✅ store role for theme persistence
      localStorage.setItem("userRole", role);

      // ✅ redirect based on role
      if (role === "admin") {
        navigate("/inventory-management", { replace: true });
      } else if (role === "manufacturer") {
        navigate("/maintenance-overview", { replace: true });
      } else {
        navigate("/inventory-management", { replace: true });
      }

    } catch (err) {
      console.error("JWT decode failed", err);
      navigate("/", { replace: true });
    }
  };

  /* =====================================================
     ROUTES
  ===================================================== */
return (
  <Routes>
    {isLoggedIn ? (
      <>
        {/* Protected App */}
        <Route
          path="/*"
          element={<HomeScreen onLogout={handleLogout} />}
        />

        {/* Redirect unknown paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </>
    ) : (
      <>
        {/* Public routes */}
        <Route
          path="/"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />

        {/* ⭐ ADD THIS */}
        <Route
          path="/forgot-password"
          element={<ForgotPasswordPage />}
        />

        {/* Redirect unknown paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </>
    )}
  </Routes>
);
}